module.exports = __webpack_public_path__ + "img/tree.1fa649ba.svg";